 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AddDevice":"AddDevice","ChatLayout":"ChatLayout","Error404":"Error404","Error429":"Error429","Error500":"Error500","ForgottenPassword":"ForgottenPassword","GuestHome":"GuestHome","Home":"Home","Impersonation":"Impersonation","Login":"Login","PublicSpedilink":"PublicSpedilink","ResetPassword":"ResetPassword","ResetPasswordCodeVerification":"ResetPasswordCodeVerification","SpedilinkUnsubscribeNotifications":"SpedilinkUnsubscribeNotifications","TSL":"TSL","TwoFactorAuthentication":"TwoFactorAuthentication","AddTSLContractor":"AddTSLContractor","GlobalLayout":"GlobalLayout","AddIssue":"AddIssue","DetailsIssue~RegisterIssue":"DetailsIssue~RegisterIssue","DetailsIssue":"DetailsIssue","RegisterIssue":"RegisterIssue","Register":"Register","Employees":"Employees","TSLConfigurator":"TSLConfigurator","CompaniesIssues":"CompaniesIssues","Issues":"Issues","Profile":"Profile","SpediLink":"SpediLink","SpedilinkMyLinks":"SpedilinkMyLinks","SpedilinkOffers":"SpedilinkOffers","System":"System","Companies":"Companies","GuestSettings":"GuestSettings","TSLContractors":"TSLContractors","CompaniesDetails":"CompaniesDetails","Reviews":"Reviews","TSLContractorDetails":"TSLContractorDetails","TSLOrders":"TSLOrders","AddTSLOrder":"AddTSLOrder","SpedilinkLinkDetails":"SpedilinkLinkDetails"}[chunkId]||chunkId) + "." + {"AddDevice":"145eab75","ChatLayout":"b3535927","Error404":"3f355729","Error429":"3cdfe929","Error500":"2d0cbfb4","ForgottenPassword":"73d937a0","GuestHome":"c4265a46","Home":"c2af198d","Impersonation":"0df7bddb","Login":"f02e5eb2","PublicSpedilink":"2f62c6dc","ResetPassword":"6e70a9fa","ResetPasswordCodeVerification":"444d52f2","SpedilinkUnsubscribeNotifications":"6ed48b4e","TSL":"d8fe9f5e","TwoFactorAuthentication":"a47b3c6d","chunk-09662e11":"17bcc638","chunk-1d7ebcf6":"6de21d37","chunk-2886923e":"ab6dc03a","chunk-29a9683c":"39c849b2","chunk-2d0d3c79":"22a1b8fc","chunk-2d224a96":"c87a55fc","chunk-2d231187":"ea4e063d","AddTSLContractor":"03f5fc80","GlobalLayout":"1b049a81","chunk-39959e7f":"b86aa259","chunk-6c3906e0":"3fdc95fb","chunk-34280d46":"28e550d9","chunk-2d0daed2":"b8b64082","chunk-50892673":"8418b1af","chunk-51dcb0be":"7fd061e6","chunk-594ccdee":"6874af21","AddIssue":"194d68a8","DetailsIssue~RegisterIssue":"abf68741","DetailsIssue":"97f5df84","RegisterIssue":"5d20ba26","Register":"6425fe93","chunk-4f7497a0":"f74656a9","chunk-6980a269":"b25e27e0","Employees":"d42c75cf","chunk-af59ec06":"01f3af4e","chunk-1cd2da12":"2e9a2393","chunk-1e077003":"04d14e92","chunk-815af874":"a1699c30","chunk-1fa926c4":"0cc90d84","chunk-79b98ffb":"13730881","chunk-786a8384":"03c9bbfe","TSLConfigurator":"91d4b91a","chunk-abb49458":"912d84a2","chunk-e177cb90":"b7872f97","CompaniesIssues":"057dbc1a","Issues":"86201342","Profile":"f1e32598","SpediLink":"9c63349e","SpedilinkMyLinks":"80a3fa71","SpedilinkOffers":"a6a0c68c","System":"56e1a144","chunk-18082c3f":"a817f720","Companies":"26789f50","GuestSettings":"a00efd83","TSLContractors":"61625d6d","chunk-7f9bc49c":"9dbf9b64","chunk-d70ef9fa":"fc875129","CompaniesDetails":"c6e76e72","Reviews":"2d383e7b","TSLContractorDetails":"64ba6b41","TSLOrders":"c834953a","AddTSLOrder":"a54236ff","SpedilinkLinkDetails":"9712f4b7","chunk-3e1994df":"1bc090ac","chunk-44718c80":"bd62c8eb","chunk-5e107ce7":"b050295c","chunk-ce924bac":"8b2d788f","chunk-679f62bc":"9ed2b7ea","chunk-859ac1be":"ee55750c","chunk-734a923f":"01d7f4c3","chunk-d6e6c11a":"69b5cdc9","chunk-2d0b8eef":"62268cde","chunk-2d0bdbe7":"51560112","chunk-2d2095ed":"88308b48","chunk-2d229b6a":"73eea0f5","chunk-780a9e22":"fe878726","chunk-f2ee9602":"35eba47d","chunk-2d0c84cf":"9cead611","chunk-2d0cba59":"e286e7cb","chunk-74a0fa2f":"a26d4ae6","chunk-2d0bd59a":"b1b49add","chunk-2d0c8838":"877fd4e7","chunk-2d0ccc04":"642c46e2","chunk-2d0d7809":"fdc46e7b","chunk-c2dc27aa":"3d641461","chunk-2d22b9db":"cf07015e","chunk-2d2315e9":"ce71bf1a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"GuestHome":1,"Home":1,"Impersonation":1,"ResetPassword":1,"ResetPasswordCodeVerification":1,"SpedilinkUnsubscribeNotifications":1,"TwoFactorAuthentication":1,"chunk-09662e11":1,"chunk-1d7ebcf6":1,"chunk-2886923e":1,"chunk-29a9683c":1,"AddTSLContractor":1,"GlobalLayout":1,"chunk-39959e7f":1,"chunk-6c3906e0":1,"chunk-50892673":1,"chunk-51dcb0be":1,"chunk-594ccdee":1,"AddIssue":1,"DetailsIssue~RegisterIssue":1,"DetailsIssue":1,"RegisterIssue":1,"Register":1,"chunk-4f7497a0":1,"chunk-6980a269":1,"Employees":1,"chunk-af59ec06":1,"chunk-1cd2da12":1,"chunk-1e077003":1,"chunk-815af874":1,"chunk-1fa926c4":1,"chunk-79b98ffb":1,"chunk-786a8384":1,"TSLConfigurator":1,"chunk-abb49458":1,"chunk-e177cb90":1,"CompaniesIssues":1,"Issues":1,"Profile":1,"SpediLink":1,"SpedilinkMyLinks":1,"SpedilinkOffers":1,"chunk-18082c3f":1,"Companies":1,"GuestSettings":1,"TSLContractors":1,"chunk-7f9bc49c":1,"CompaniesDetails":1,"Reviews":1,"TSLContractorDetails":1,"TSLOrders":1,"AddTSLOrder":1,"SpedilinkLinkDetails":1,"chunk-3e1994df":1,"chunk-44718c80":1,"chunk-5e107ce7":1,"chunk-ce924bac":1,"chunk-679f62bc":1,"chunk-859ac1be":1,"chunk-734a923f":1,"chunk-f2ee9602":1,"chunk-74a0fa2f":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AddDevice":"AddDevice","ChatLayout":"ChatLayout","Error404":"Error404","Error429":"Error429","Error500":"Error500","ForgottenPassword":"ForgottenPassword","GuestHome":"GuestHome","Home":"Home","Impersonation":"Impersonation","Login":"Login","PublicSpedilink":"PublicSpedilink","ResetPassword":"ResetPassword","ResetPasswordCodeVerification":"ResetPasswordCodeVerification","SpedilinkUnsubscribeNotifications":"SpedilinkUnsubscribeNotifications","TSL":"TSL","TwoFactorAuthentication":"TwoFactorAuthentication","AddTSLContractor":"AddTSLContractor","GlobalLayout":"GlobalLayout","AddIssue":"AddIssue","DetailsIssue~RegisterIssue":"DetailsIssue~RegisterIssue","DetailsIssue":"DetailsIssue","RegisterIssue":"RegisterIssue","Register":"Register","Employees":"Employees","TSLConfigurator":"TSLConfigurator","CompaniesIssues":"CompaniesIssues","Issues":"Issues","Profile":"Profile","SpediLink":"SpediLink","SpedilinkMyLinks":"SpedilinkMyLinks","SpedilinkOffers":"SpedilinkOffers","System":"System","Companies":"Companies","GuestSettings":"GuestSettings","TSLContractors":"TSLContractors","CompaniesDetails":"CompaniesDetails","Reviews":"Reviews","TSLContractorDetails":"TSLContractorDetails","TSLOrders":"TSLOrders","AddTSLOrder":"AddTSLOrder","SpedilinkLinkDetails":"SpedilinkLinkDetails"}[chunkId]||chunkId) + "." + {"AddDevice":"31d6cfe0","ChatLayout":"31d6cfe0","Error404":"31d6cfe0","Error429":"31d6cfe0","Error500":"31d6cfe0","ForgottenPassword":"31d6cfe0","GuestHome":"c0a96577","Home":"731ed283","Impersonation":"f4fd496c","Login":"31d6cfe0","PublicSpedilink":"31d6cfe0","ResetPassword":"41de0b3d","ResetPasswordCodeVerification":"411cac8c","SpedilinkUnsubscribeNotifications":"df9d9a7c","TSL":"31d6cfe0","TwoFactorAuthentication":"411cac8c","chunk-09662e11":"d18140ee","chunk-1d7ebcf6":"f2c87d22","chunk-2886923e":"be30d337","chunk-29a9683c":"42100da0","chunk-2d0d3c79":"31d6cfe0","chunk-2d224a96":"31d6cfe0","chunk-2d231187":"31d6cfe0","AddTSLContractor":"df9d9a7c","GlobalLayout":"651c839d","chunk-39959e7f":"b5d8acb2","chunk-6c3906e0":"7db61165","chunk-34280d46":"31d6cfe0","chunk-2d0daed2":"31d6cfe0","chunk-50892673":"28efad74","chunk-51dcb0be":"3ffcad8e","chunk-594ccdee":"2090ba31","AddIssue":"49830f27","DetailsIssue~RegisterIssue":"b4163c6e","DetailsIssue":"49830f27","RegisterIssue":"41101002","Register":"9340e1a9","chunk-4f7497a0":"48a07237","chunk-6980a269":"1c538684","Employees":"5b33ea22","chunk-af59ec06":"48984adc","chunk-1cd2da12":"913ae3e5","chunk-1e077003":"913ae3e5","chunk-815af874":"eb2b830f","chunk-1fa926c4":"ebbea071","chunk-79b98ffb":"43b55ea8","chunk-786a8384":"d18140ee","TSLConfigurator":"b572fa1b","chunk-abb49458":"b5fa9383","chunk-e177cb90":"e4546627","CompaniesIssues":"f4fd496c","Issues":"f4fd496c","Profile":"422d3a98","SpediLink":"28e3aa5f","SpedilinkMyLinks":"657e2626","SpedilinkOffers":"df8d4178","System":"31d6cfe0","chunk-18082c3f":"79741636","Companies":"542ddc39","GuestSettings":"29c2313c","TSLContractors":"a8988ce8","chunk-7f9bc49c":"0d4bf9de","chunk-d70ef9fa":"31d6cfe0","CompaniesDetails":"63629c96","Reviews":"d36aefd2","TSLContractorDetails":"f568ff71","TSLOrders":"35d333b3","AddTSLOrder":"1e3bbaf5","SpedilinkLinkDetails":"9f9cb26e","chunk-3e1994df":"f2a12b30","chunk-44718c80":"327e01bd","chunk-5e107ce7":"5a2a8b5b","chunk-ce924bac":"210a3cc9","chunk-679f62bc":"49830f27","chunk-859ac1be":"a167ca21","chunk-734a923f":"bdadaf8b","chunk-d6e6c11a":"31d6cfe0","chunk-2d0b8eef":"31d6cfe0","chunk-2d0bdbe7":"31d6cfe0","chunk-2d2095ed":"31d6cfe0","chunk-2d229b6a":"31d6cfe0","chunk-780a9e22":"31d6cfe0","chunk-f2ee9602":"f4fd496c","chunk-2d0c84cf":"31d6cfe0","chunk-2d0cba59":"31d6cfe0","chunk-74a0fa2f":"cd5ae6a4","chunk-2d0bd59a":"31d6cfe0","chunk-2d0c8838":"31d6cfe0","chunk-2d0ccc04":"31d6cfe0","chunk-2d0d7809":"31d6cfe0","chunk-c2dc27aa":"31d6cfe0","chunk-2d22b9db":"31d6cfe0","chunk-2d2315e9":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
